import script from "./Edit.vue?vue&type=script&lang=ts&setup=true"
export * from "./Edit.vue?vue&type=script&lang=ts&setup=true"

import "./Edit.vue?vue&type=style&index=0&id=6c1b739d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c1b739d"]])

export default __exports__